import L from 'leaflet';
import { getAttachmentUrl } from '../constants';

export function getLocation(row) {
  return [
    (row.site_street_number || '') + ' ' + (row.site_street_name || ''),
    row.site_cross_street,
    row.site_city,
    // row.site_state,
    row.site_zip_code,
  ].filter(Boolean).join(', ');
}

export function getPathname({ portalID, profile, path }) {
  const id = `/${profile}-${portalID}`;

  return path.includes(id) ? path : `${id}/${portalID}${path}`;
}

function isJsonString(str) {
  try { JSON.parse(str); } catch (e) { return false; }
  return true;
}

export const getDefaultLeafletBoundaries = () => {
  let boundaries = root?.app?.dbConfig?.MAP_BASE_BOUNDARIES;
  if (!boundaries || !isJsonString(boundaries)) return null;

  let bnds = JSON.parse(boundaries);
  return L.latLngBounds(bnds);
};

export const fitToBounds = (items) => {
  const leafletMap = window.map || window?.mapStore?.map;
  if (!leafletMap || !items.length) {
    console.log('no map to zoomto');
    return;
  }
  let bounds = L.latLngBounds();
  items.forEach(item => item.latitude && item.longitude && bounds.extend({ lat: item.latitude, lng: item.longitude }, 0));
  if (leafletMap && bounds._northEast && bounds._southWest) {
    leafletMap?.fitBounds?.(bounds, { maxZoom: 18 });
  } else {
    const { latitude, longitude } = root?.app?.userPosition || getDefaultLeafletBoundaries();
    setTimeout(() => (latitude && longitude && leafletMap?.setView?.([latitude, longitude], 15, { maxZoom: 15 })), 1);
  }
};

export const zoomToSelected = (items) => {
  const leafletMap = window.map || (window.mapStore && window.mapStore.map);

  if (!leafletMap) {
    return null;
  }
  if (items && !!items.length) {
    let bounds = L.latLngBounds();
    items.forEach(item => (
      item._isSelected && item.latitude && item.longitude && bounds.extend({ lat: item.latitude, lng: item.longitude }, 0)
    ));
    if (leafletMap && bounds._northEast && bounds._southWest) {
      leafletMap.fitBounds(bounds, { maxZoom: 18 });
    }
  }
};

export const formatBoolean = (value) => ([true, 1, '1', 'Y'].includes(value) ? 'Y' : 'N');

export const validateMessage = (validateErrors = {}, MAP_FIELD_CODES) => {
  const errors = [];
  Object.keys(validateErrors).forEach((key) => {
    if (validateErrors[key]) {
      errors.push(`${MAP_FIELD_CODES[key]}: ${validateErrors[key]}`);
    }
  });

  return errors.join('<br />');
};

export const sortArray = ({ data, sortKey, sorted, columns }) => {
  const newData = [...data];
  const col = columns.find(c => c.name === sortKey) || {};

  const format = (row) => {
    const value = row[sortKey];
    if (value == null) return null;

    if (col.type === 'number') {
      return parseFloat(value);
    }

    if (col.type === 'date') {
      return new Date(value);
    }

    return value;
  };

  if (!col?.name) return newData;

  const direction = sorted[sortKey]; // 'asc' or 'desc'

  newData.sort((a, b) => {
    const valA = format(a);
    const valB = format(b);

    // nulls always go to the bottom
    const isANull = valA === null || valA === undefined || Number.isNaN(valA);
    const isBNull = valB === null || valB === undefined || Number.isNaN(valB);

    if (isANull && isBNull) return 0;
    if (isANull) return 1;  // a is null => a goes after b
    if (isBNull) return -1; // b is null => b goes after a

    // Both values are valid, proceed with normal sort
    if (direction === 'asc') {
      return valA > valB ? 1 : valA < valB ? -1 : 0;
    } else {
      return valA < valB ? 1 : valA > valB ? -1 : 0;
    }
  });

  return newData;
};

export const sortDataWithTwoGroupings = ({ data, sorted, columns, orders }) => {
  const firstOrderKey = orders[0];
  const secondOrderKey = orders[1];
  let newData = [...data];
  newData = sortArray({ data: newData, sortKey: firstOrderKey, sorted, columns });

  const groupedData = newData.reduce((acc, item) => {
    const itemKey = item[firstOrderKey];
    if (!acc[itemKey]) {
      acc[itemKey] = [];
    }

    acc[itemKey] = [...acc[itemKey], item];

    return acc;
  }, {});

  return Object.values(groupedData).reduce((acc, items) => {
    acc = [...acc, ...sortArray({ data: items, sortKey: secondOrderKey, sorted, columns })];

    return acc;
  }, []);
};

export function sortData(data, sorted, columns = []) {
  if (!data || !data.length) return data;

  const orders = Object.keys(sorted).filter(d => sorted[d]);

  let newData = [...data];

  if (orders?.length === 2) {
    return sortDataWithTwoGroupings({ data, sorted, columns, orders });
  }

  orders.forEach(d => {
    newData = sortArray({ data: newData, sortKey: d, sorted, columns });
  });

  return newData;
}

export function saveJSONParse(json) {
  try {
    return JSON.parse(json);
  } catch (e) {
    return json;
  }
}

export const getUrl = (attach_id, width, height, crop) =>  {
  if (!attach_id) return null;

  const url = new URL(getAttachmentUrl());
  Object.entries({
    skey: root.app.getToken(),
    attach_id,
    profile: root.app.profile,
    w: width,
    h: height,
    crop
  }).filter(([key, val]) => val).forEach(([key, val]) => url.searchParams.set(key, val));

  return url.toString();
};
